import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { PaginatedProvider } from './PaginatedProvider';
import { JobActivityCore } from '../../types/jobs';
import { getJobActivities } from '../../services/jobTypesService';
import { useParams } from 'react-router-dom';
import { updateJobActivitiesState, jobActivitiesState, loadingJobActivitiesState, searchJobActivitiesState, jobActivitiesPageState } from '../../storage/jobTypesStates';

export function JobActivitiesProvider() {
  const { jobTypeId } = useParams();
  const updateJobActivities = useRecoilValue(updateJobActivitiesState);
  const resetUpdateJobActivities = useResetRecoilState(updateJobActivitiesState);
  const setPaginatedJobActivities = useSetRecoilState(jobActivitiesState);
  const setLoadingJobActivities = useSetRecoilState(loadingJobActivitiesState);

  if(!jobTypeId) return null;

  return (
    <PaginatedProvider<JobActivityCore>
      searchState={searchJobActivitiesState}
      pageState={jobActivitiesPageState}
      getPaginated={(page, search) => getJobActivities(jobTypeId, page, search)}
      setPaginated={setPaginatedJobActivities}
      onSearchChange={() => {
        // TODO: Do something if needed when search changes.
      }}
      onUpdateFinish={() => {
        resetUpdateJobActivities();
      }}
      setLoading={setLoadingJobActivities}
      update={updateJobActivities}
    />
  );
}
